//Update count function
export function updatecount(payload) {
  return {
    type: "UPDATE_COUNT",
    payload,
  };
}
